import React, { useEffect } from 'react';
import { Button, Form, Modal } from 'antd';
import './AgreementDocumentsModal.less';
import { UserCheckBoxAgreements } from '../UserCheckBoxAgreements/UserCheckBoxAgreements';
import { FormInstance } from 'antd/lib/form';

interface Props {
  isOpened: boolean;
  handleOk: () => void;
  form: FormInstance;
}

const AgreementDocumentsModal = (props: Props) => {
  const { isOpened, handleOk } = props;
  const values = Form.useWatch([], props?.form);
  const [disabled, setDisabled] = React.useState<boolean>(false);

  useEffect(() => {
    props?.form
      .validateFields({ validateOnly: true })
      .then(() => {
        setDisabled(true);
      })
      .catch(() => setDisabled(false));
  }, [values]);

  return (
    <Modal
      wrapClassName="agreement-user-modal"
      open={isOpened}
      width={343}
      footer={false}
      bodyStyle={{
        padding: '20px 20px 20px 20px',
        background: 'rgba(244, 244, 244, 1)',
      }}
      maskClosable={false}
      closable={false}
    >
      <div className="logo mb40" />
      <Form form={props?.form}>
        <UserCheckBoxAgreements />
      </Form>
      <Button
        key={1}
        type="primary"
        disabled={!disabled || Object.keys(values)?.length === 0}
        style={{ width: '100%', fontFamily: 'PT Serif', fontSize: '14px' }}
        onClick={handleOk}
      >
        Продолжить
      </Button>
    </Modal>
  );
};

export default AgreementDocumentsModal;
